import React from 'react';
import DownArrow from '../components/downArrow';

export default class HomeFour extends React.Component {

	render(){
		return (
			<div id="home_four" className="home_four hide_overflow">
				<div className="blacker_color">
				<div className="container h-100per">
					<div className="row h-100per">
						<div className="col-md-6 ">

						</div>
						<div className="col-md-6 h-100per ">

							<div className="outer-center">
								<div className="middle-center">
									<div className="inner-center home_four_content">
										<h1>What makes Tipigo different</h1>
										<div className="green_line"></div>
										<p>
											After years of R&D, our team has successfully devised a way to synergize different investment disciplines into a unified investment strategy that delivers consistent outperformance.
											<br/><br/>
											By combining big data science and specialized analyst recommendations in real time, we are able to identify exceptional investment opportunities just in time to reap the profit.

										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
				{/* <DownArrow elementId="home_four"></DownArrow> */}

		    </div>

		);
	}

}



// WEBPACK FOOTER //
// ./src/js/components/HomeFour.js